import Variable from 'Components/ContractGenerator/layouts/Variable';
import i18n from 'Dictionaries/i18n';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Alert from 'ViatoUi/Extranet/Surfaces/Alert';
import Badge from 'ViatoUi/Shared/DataDisplay/Badge';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Anchor, Headline, Paragraph } from 'ViatoUi/Shared/Typo';

const Extension = ({ translationKey, components, translationNamespace }) => {
	const { t } = useTranslation(translationNamespace);

	const getTransComponents = () => {
		const transComponents = {};
		components.forEach((component, index) => {
			let { props: componentProps } = component;
			if (component.type === 'anchor' && !componentProps?.href?.includes('mailto:') && !componentProps?.href?.includes('tel:')) {
				componentProps = { ...componentProps, href: `${componentProps?.href}?lang=${i18n.language}` };
			}

			switch (component.type) {
				case 'anchor':
					transComponents[`Component${index}`] = <Anchor {...componentProps} />;
					break;

				case 'headline':
					transComponents[`Component${index}`] = <Headline {...componentProps} />;
					break;

				case 'paragraph':
					transComponents[`Component${index}`] = <Paragraph {...componentProps} />;
					break;

				case 'break':
					transComponents[`Component${index}`] = <br {...componentProps} />;
					break;

				case 'strong':
					transComponents[`Component${index}`] = <strong {...componentProps} />;
					break;

				case 'spacer':
					transComponents[`Component${index}`] = <Spacer {...componentProps} />;
					break;

				case 'badge':
					transComponents[`Component${index}`] = <Badge {...componentProps} />;
					break;

				case 'alert':
					transComponents[`Component${index}`] = <Alert {...componentProps} />;
					break;

				case 'variable':
					transComponents[`Component${index}`] = <Variable {...componentProps} />;
					break;

				case 'icon':
					transComponents[`Component${index}`] = <Icon {...componentProps} />;
					break;

				default:
					transComponents[`Component${index}`] = <div {...componentProps} />;
					break;
			}
		});

		return transComponents;
	};

	return <Trans components={getTransComponents(components)} i18nKey={translationKey} t={t} />;
};

Extension.propTypes = {
	components: PropTypes.array.isRequired,
	translationKey: PropTypes.string.isRequired,
	translationNamespace: PropTypes.string.isRequired
};

export default Extension;
